import { ITheme } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    heroBannerFooterBtns: {
      display: 'flex',
      gap: 8,

      '& > div button': {
        padding: [8, 16],

        '& > span': {
          color: '#4C4C4C',
          fontsize: '16px',
          lineHeight: '24px',
        },

        '& svg path': {
          fill: '#4C4C4C',
          transition: 'color 0.3s ease-in-out 0s',
        },

        '&:hover svg path': {
          fill: colors.primary,
        },
      },
    },
    btnTryAgain: {
      padding: 0,
      margin: 0,
      border: 0,
      background: 'transparent',
      textDecoration: 'underline',

      '&:hover': {
        padding: 0,
        margin: 0,
        border: 0,
        background: 'transparent',
      },
    },
  }),
  { name: 'Alert', link: true },
);

export default useStyles;
